import * as React from "react";

import "./marketing-center-menu-desktop.scss"

import {Link}                   from "react-router-dom";
import {cs}                     from "@Common/react/chain-services";
import {UseState}               from "@Common/react/use-state";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {MenuHeaderDesktop}      from "@Xpresso/routes/account/common/account-layout/menu/menu-header-desktop";
import {marketingCenterLinks}   from "@Xpresso/routes/marketing-center/common/marketing-center-common";

export const MarketingCenterMenuDesktop = ({profile, helpMgmt, linkActive, url}) => cs(
    ['resourcesExpanded', ({}, next) => UseState({
        initValue: false,
        next,
    })],
    ({resourcesExpanded}) => (
        <div className="menu menu-070">

            <MenuHeaderDesktop profile={profile} />

            <div className="menu-desktop-CH3CO2">
                {
                    marketingCenterLinks.map(link => (
                        <React.Fragment key={link.linkLabel}>
                            {menuLink(link, linkActive, url)}
                        </React.Fragment>
                    ))                
                }

                {helpMgmt?.value?.helpmgmt.length > 0 && menuDropdown('Resources', 'faLink', resourcesExpanded)}                
                {
                    resourcesExpanded.value
                    ?
                    helpMgmt?.value?.helpmgmt.map(helpMgmtItem => (
                        <React.Fragment key={helpMgmtItem.name}>
                            {menuDropdownItem(helpMgmtItem)}
                        </React.Fragment>                       
                    ))
                    :
                    null                 
                }
            </div>

        </div>
    ),
);

export const menuLink = (marketingCenterLink, linkActive, url) => {
    return (
        <div className={
                    marketingCenterLink === linkActive.value
                    ? 
                    'menu-link active'
                    :
                    'menu-link'
                } 
        >
            <FontAwesomeIcon 
                icon={require('@fortawesome/free-solid-svg-icons')[marketingCenterLink.icon]}
                className='menu-link-icon left'
            />

            <Link
                className='menu-link-path'
                to={marketingCenterLink.link}
                xd-qa-type="link"
                xd-qa-name={marketingCenterLink.linkLabel}
                onClick={() => {
                    linkActive.onChange(marketingCenterLink)
                }}
            >                
                {marketingCenterLink.linkLabel}
            </Link>

            <FontAwesomeIcon 
                icon={require('@fortawesome/free-solid-svg-icons')['faCaretUp']}
                className='menu-link-icon right placeholder'                    
            />
                     
        </div>
    )
}

const menuDropdown = (text, icon, isExpanded) => {
    return (
        <div 
            className={
                isExpanded.value
                ?
                'menu-dropdown expanded'
                :
                'menu-dropdown'
            }
            onClick={(e) => {
                e.stopPropagation()
                isExpanded.onChange(!isExpanded.value)
            }}   
            xd-qa-type="link"
            xd-qa-name={text}
        >
            <FontAwesomeIcon 
                icon={require('@fortawesome/free-solid-svg-icons')[icon]}
                className='menu-dropdown-icon left'
            />

            <div className='menu-dropdown-text' xd-qa-type="text" xd-qa-name={text}>
                {text}
            </div>

            <FontAwesomeIcon 
                icon={require('@fortawesome/free-solid-svg-icons')
                    [ 
                    isExpanded.value
                    ?
                    'faCaretUp'
                    :
                    'faCaretDown'
                ]}
                className='menu-dropdown-icon right'
            />

        </div>
    )
}

export const menuDropdownItem = (item) => {
    return (
        <div className="menu-dropdown-item" title={item.name}>
            <a 
                className="menu-dropdown-item-link"
                href={item.url} 
                target='blank' 
                rel='noopener noreferrer'
                xd-qa-type="link"
                xd-qa-name={item.name}
            >
                {item.name}
            </a>
        </div>
    )
}
